import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=14962898&scoped=true&"
import script from "./TextElement.vue?vue&type=script&lang=js&"
export * from "./TextElement.vue?vue&type=script&lang=js&"
import style0 from "./TextElement.vue?vue&type=style&index=0&id=14962898&scoped=true&lang=css&"
import style1 from "./TextElement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14962898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14962898')) {
      api.createRecord('14962898', component.options)
    } else {
      api.reload('14962898', component.options)
    }
    module.hot.accept("./TextElement.vue?vue&type=template&id=14962898&scoped=true&", function () {
      api.rerender('14962898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/TextElement.vue"
export default component.exports